import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const PriceRuleCheckbox = ({ value, setValue, label }) => (
    <FormControlLabel
        control={<Checkbox checked={value} onChange={event => setValue(event.target.checked)} />}
        label={label}
    />
);

export default PriceRuleCheckbox;
